<template>
  <div id="features" class="section">
    <div v-if="data">
      <h1 class="component-title" v-if="isComponent">
        <i class="anyteachicon anyteach-anquanbaozhang2" />教学保障
      </h1>
      <h1 v-else>AnyTeach 教学保障</h1>
      <div class="card">
        <div class="item" v-for="item in data" :key="item.title">
          <div class="left">
            <i :style="setColor" class="gradient" :class="item.icon" />
          </div>
          <div class="right">
            <h3>{{ item.title }}</h3>
            <h4>{{ item.desc }}</h4>
          </div>
        </div>
      </div>
      <router-link tag="div" to="/contact" id="contact" class="card">
        <div :style="setColor" class="left gradient">联系小管家</div>
        <div class="right">
          点击咨询您的专属小管家
          <i class="anyteachicon anyteach-next" />
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Features",
  props: {
    isComponent: {
      type: Boolean,
      default: false,
    },
    courseType: {
      type: Number,
      default: 0,
    },
    color: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      data: null,
    }
  },
  computed: {
    setColor() {
      if (!this.color) return ""
      return `color: ${this.color}`
    },
    setBgd() {
      if (!this.color) return ""
      return `background: ${this.color}; border-color: ${this.color}`
    },
  },
  methods: {
    async getData() {
      try {
        let query = "front_page_guarentees"
        if (this.isComponent && this.courseType) {
          query = `course_guarentee_${this.courseType}`
        }
        const res = await this.$api.api.CUSTOM(query)
        if (res) {
          this.data = JSON.parse(res.value_1)
        }
      } catch (err) {
        throw new Error(err)
      }
    },
  },
  created() {
    this.getData()
  },
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
#features {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  .gradient {
    // $color1: #ff0000;
    // $color2: #ff8585;
    // background-clip: text;
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
    // background-image: -webkit-linear-gradient(left top, $color1, $color2);
    // background-image: -moz-linear-gradient(left top, $color1, $color2);
    // background-image: -o-linear-gradient(left top, $color1, $color2);
    // background-image: -ms-linear-gradient(left top, $color1, $color2);
    // background-image: linear-gradient(left top, $color1, $color2);
    // background-color: $color1;
    color: $red;
  }
  .card {
    background: #f7f7f7;
    border-radius: 4px;
    padding: 10px 15px;
    margin: 10px 0 10px 0;

    &:last-child {
      margin-bottom: 0;
    }
    .item {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      &:last-child {
        margin-bottom: 0;
      }
      .left {
        padding-right: 10px;
        i {
          font-size: 35px;
        }
      }
      .right {
        h3 {
          @include avenir-demi();
          font-size: 1rem;
        }
        h4 {
          @include avenir();
          font-size: 0.9rem;
          font-weight: 400;
          opacity: 0.6;
          line-height: 1.2;
        }
      }
    }
  }
  #contact {
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: all 0.1s;

    &:active {
      opacity: 0.6;
    }
    .left,
    .right {
      font-size: 0.9rem;
      i {
        font-size: inherit;
      }
    }
    .left {
      @include avenir-demi();
    }
    .right {
      opacity: 0.6;
    }
  }
  .component-title {
    padding-top: 15px;
    i {
      margin-right: 3px;
    }
  }
}
</style>
